import { combineReducers } from "@reduxjs/toolkit";
import accountingSlice from "./slices/accountingSlice";
import journalSlice from "./slices/journalSlice";
import accountingQuotationSlice from "./slices/accountingQuotationSlice";
import accountMovementPaymentSlice from "./slices/accountMovementPaymentSlice";
import accountingManualSeatSlice from "./slices/accountingManualSeatSlice";
import accountingCXCPReportSlice from "./slices/accountingCXCPReportSlice";
import accountingInvoicesXEmployeeReportSlice from "./slices/accountingInvoicesXEmployeeReportSlice";
import accountingInvoicesXEmployeeGroupedReportSlice from "./slices/accountingInvoicesXEmployeeGroupedReportSlice";
import accountingExpensesSlice from "./slices/accountingExpensesSlice";
import creditNoteSlice from "./slices/creditNoteSlice";
import invoiceTypeSlice from "./slices/invoiceTypeSlice";
import journalPaymentTypeSlice from "./slices/JournalPaymentTypeSlice";

export default combineReducers({
  accountMovementPayment: accountMovementPaymentSlice,
  accounting: accountingSlice,
  accountingManualSeat: accountingManualSeatSlice,
  accountingQuotation: accountingQuotationSlice,
  accountingCXCPReport: accountingCXCPReportSlice,
  accountingInvoicesXEmployeeReports: accountingInvoicesXEmployeeReportSlice,
  accountingInvoicesXEmployeeGroupedReports:
    accountingInvoicesXEmployeeGroupedReportSlice,
  accountingExpense: accountingExpensesSlice,
  creditNote: creditNoteSlice,
  invoiceTypes: invoiceTypeSlice,
  journal: journalSlice,
  journalPaymentType: journalPaymentTypeSlice,
});
